<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" *ngIf="visible">
  <div class="bg-white w-165 rounded-xl shadow-xl p-6 relative animate-fadeIn">
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center gap-2">
        <h2 class="text-lg font-semibold">Edit Profile Picture</h2>
      </div>

      <button class="text-gray-500 hover:text-black text-xl" (click)="close()">✕ </button>
    </div>
    <div class="space-y-5">
      <div
        class="relative w-60 h-60 mx-auto overflow-hidden rounded-full border-2 border-dashed border-gray-300 bg-base flex items-center justify-center"
      >
        <img
          *ngIf="image"
          [src]="image"
          class="absolute max-w-full max-h-full object-contain"
          [style.transform]="'scale(' + zoom + ') rotate(' + rotation + 'deg)'"
          style="transform-origin: center center"
        />
      </div>
      <canvas #canvas width="512" height="512" class="hidden"></canvas>
      <div>
        <p class="text-sm font-medium mb-2">Choose Image</p>

        <app-button-reusable
          type="button"
          variant="neutral"
          appearance="outline"
          [disabled]="saving"
          (click)="fileInput.click()"
        >
          <app-icon-reusable
            [icon]="cloudupload"
            [size]="16"
            class="flex justify-center"
          ></app-icon-reusable>
          Choose
        </app-button-reusable>

        <input
          #fileInput
          type="file"
          accept="image/jpeg,image/png"
          class="hidden"
          (change)="onFileChange($event)"
        />

        <p class="text-xs text-gray-500 mt-2">
         Recommended size: 512 × 512 px. | formats: JPG, PNG | Max file size: 5MB.
        </p>
      </div>
      <div class="flex items-center justify-center gap-3">
        <button class="h-9 w-9 p-2 border border-slate300 rounded-full" (click)="rotateLeft()">
          <app-icon-reusable
            [icon]="arrowcounterclockwise"
            [size]="16"
            class="flex justify-center"
          ></app-icon-reusable>
        </button>
        <div  class="h-9 border border-slate300 rounded-3xl flex items-center gap-2 ">
          <button
            class="h-10 w-10 p-2"
            (click)="zoomOut()"
          >
            <app-icon-reusable
            [icon]="minusIcon"
            [size]="18"
            class="flex justify-center"
          ></app-icon-reusable>
          </button>

          <input type="range" [(ngModel)]="zoom" min="0.5" max="3" step="0.1" class="w-32 accent-indigo-600 cursor-pointer" />

          <button class="h-10 w-10 p-2" (click)="zoomIn()">
              <app-icon-reusable
            [icon]="plusIcon"
            [size]="18"
            class="flex justify-center"
          ></app-icon-reusable>
          </button>
        </div>
        <button class="h-9 w-9 p-2 border border-slate300 rounded-full" (click)="rotateRight()">
          <app-icon-reusable
            [icon]="arrowclockwise"
            [size]="16"
            class="flex justify-center"
          ></app-icon-reusable>
        </button>
      </div>
      <div class="flex justify-end gap-3 pt-4">
        <app-button-reusable
          type="button"
          variant="neutral"
          appearance="outline"
          [disabled]="saving"
          (clicked)="close()"
        >
          Cancel
        </app-button-reusable>

        <app-button-reusable [loading]="saving" [disabled]="saving" (click)="save()"> Save Image </app-button-reusable>
      </div>
    </div>
  </div>
</div>
